import type { AddClauseVariationsProps, BlockState } from '../types';

export const addClauseVariationsReducer = (
    state: BlockState,
    { clauseId, blockId, data }: AddClauseVariationsProps
) => ({
    ...state,
    blocks: state.blocks.map(block =>
        block.id === blockId
            ? {
                  ...block,
                  groups: [
                      {
                          fields: block.groups[0].fields.map(field =>
                              field.id === clauseId
                                  ? {
                                        ...field,
                                        content: field.content.map(item => ({ ...item, show: false })),
                                        variationsField: { ...data },
                                        show: false
                                    }
                                  : field
                          )
                      }
                  ]
              }
            : block
    )
});
